var _rect, _g, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinousmonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 30,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10.9997,
    width: 30,
    height: 19.6309,
    fill: "#1BE4F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7481 25.8185C29.2639 25.8185 30.5523 25.3957 31.6134 24.5501C32.6744 23.7044 33.2049 22.6776 33.2049 21.4695C33.2049 20.2615 32.6744 19.2346 31.6134 18.389C30.5523 17.5433 29.2639 17.1205 27.7481 17.1205C26.2323 17.1205 24.9439 17.5433 23.8828 18.389C22.8218 19.2346 22.2913 20.2615 22.2913 21.4695C22.2913 22.6776 22.8218 23.7044 23.8828 24.5501C24.9439 25.3957 26.2323 25.8185 27.7481 25.8185ZM27.7481 24.0789C26.8386 24.0789 26.0656 23.8252 25.429 23.3178C24.7923 22.8105 24.474 22.1943 24.474 21.4695C24.474 20.7447 24.7923 20.1286 25.429 19.6212C26.0656 19.1138 26.8386 18.8601 27.7481 18.8601C28.6576 18.8601 29.4306 19.1138 30.0673 19.6212C30.7039 20.1286 31.0222 20.7447 31.0222 21.4695C31.0222 22.1943 30.7039 22.8105 30.0673 23.3178C29.4306 23.8252 28.6576 24.0789 27.7481 24.0789ZM27.7481 28.7178C24.7974 28.7178 22.1094 28.0615 19.6841 26.7487C17.2589 25.436 15.5005 23.6762 14.4092 21.4695C15.5005 19.2628 17.2589 17.5031 19.6841 16.1903C22.1094 14.8776 24.7974 14.2212 27.7481 14.2212C30.6988 14.2212 33.3868 14.8776 35.8121 16.1903C38.2374 17.5031 39.9957 19.2628 41.087 21.4695C39.9957 23.6762 38.2374 25.436 35.8121 26.7487C33.3868 28.0615 30.6988 28.7178 27.7481 28.7178ZM27.7481 26.7849C30.0319 26.7849 32.1287 26.3058 34.0386 25.3474C35.9485 24.389 37.4087 23.0964 38.4192 21.4695C37.4087 19.8427 35.9485 18.5501 34.0386 17.5917C32.1287 16.6333 30.0319 16.1541 27.7481 16.1541C25.4643 16.1541 23.3675 16.6333 21.4576 17.5917C19.5477 18.5501 18.0875 19.8427 17.077 21.4695C18.0875 23.0964 19.5477 24.389 21.4576 25.3474C23.3675 26.3058 25.4643 26.7849 27.7481 26.7849Z",
    fill: "#014AAA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 57,
    height: 58
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -0.000289917,
    width: 57,
    height: 57,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 49.8747L19 47.4997L23.75 42.7497L9.5 42.7497C8.19375 42.7497 7.07552 42.2846 6.14531 41.3544C5.2151 40.4242 4.75 39.306 4.75 37.9997L4.75 11.8747C4.75 10.5685 5.2151 9.45023 6.14531 8.52002C7.07552 7.58981 8.19375 7.12471 9.5 7.12471L47.5 7.12471C48.8063 7.12471 49.9245 7.58981 50.8547 8.52002C51.7849 9.45023 52.25 10.5685 52.25 11.8747L52.25 37.9997C52.25 39.306 51.7849 40.4242 50.8547 41.3544C49.9245 42.2846 48.8063 42.7497 47.5 42.7497L33.25 42.7497L38 47.4997L38 49.8747L19 49.8747ZM9.5 30.8747L47.5 30.8747L47.5 11.8747L9.5 11.8747L9.5 30.8747Z",
    fill: "#014AAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinousmonitoring);
export default __webpack_public_path__ + "static/media/continous monitoring.03592d9d9932bc98378a2df3072b6a56.svg";
export { ForwardRef as ReactComponent };